import React from 'react'

export const BurgerNav = (props) => {
    return (
        <div style={{ ...props.style, width:'40px', padding:'0 0 0 15px'}}>
        <svg
            viewBox="0 0 451 451"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill={props.color || '#000'}
                stroke={props.stroke || '#000'}
                strokeWidth={props.strokeWidth || 3}
                d="M 0 382.5 h 459 v -51 H 0 V 382.5 Z M 0 255 h 459 v -51 H 0 V 255 Z M 0 76.5 v 51 h 459 v -51 H 0 Z" />
        </svg>
    </div>
    )
}
